import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const documentTypeService = createApi({
    reducerPath: 'documentTypeService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['DocumentType'],
    endpoints: (builder) => ({
        getAllDocumentType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentTypeController.getAllDocumentType}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                    // body: body.payload,
                }
            }
        }),
        getDocumentTypeById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentTypeController.getDocumentTypeById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                    // body: body.payload,
                }
            }
        }),
        saveDocumentType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentTypeController.saveDocumentType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateDocumentType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentTypeController.updateDocumentType}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteDocumentType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentTypeController.deleteDocumentType}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getDocumentTypeWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentTypeController.getAllDocumentTypeWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllDocumentType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentTypeController.findAllDocumentType}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveDocumentType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentTypeController.bulkSaveDocumentType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});
export const {
    useGetAllDocumentTypeMutation,
    useSaveDocumentTypeMutation,
    useUpdateDocumentTypeMutation,
    useDeleteDocumentTypeMutation,
    useGetDocumentTypeByIdMutation,
    useGetDocumentTypeWithSearchMutation,
    useFindAllDocumentTypeMutation,
    useBulkSaveDocumentTypeMutation,
} = documentTypeService;